switch(process.env.STAGE){
    case 'dev':
        global.baseUrl = 'https://cumulus.jidianyun.net';
        break;
    case 'test':
        global.baseUrl = 'https://cumulus.jidianyun.net';
        break;
    case 'pro':
        global.baseUrl = 'https://cumulus.jidianyun.net';
        break;
   
    case 'build_test':
        global.baseUrl = 'https://cumulus.jidianyun.net';
        break;
    case 'production':
        global.baseUrl = 'https://cumulus.jidianyun.net';
        break;
}
